import { render } from "./index.vue?vue&type=template&id=546a1619&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=546a1619&lang=scss&scoped=true"

import exportComponent from "E:\\4-6 项目\\蚂蚁快捷导航\\navigation\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546a1619"]])

export default __exports__